// extracted by mini-css-extract-plugin
module.exports = {"container":"va","categoryItem":"wa","active":"xa"};